import React from 'react';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import MemberLocation from './MemberLocation';
import MemberLocationList from './MemberLocationList';

const MemberPreferencesContent = ({ preferences, onChange }) => {
      
    return (
        <Paper style={{ padding: '1rem' }}>
            <Typography variant="h5" color="initial">Where you live</Typography>
            <Typography variant="subtitle2">Tell us roughly where you live and how far you're prepared to travel</Typography>
            <div style={{marginTop: '1rem'}}>
                <MemberLocation value={preferences.location} onChange={onChange} />
                <MemberLocationList 
                    list="likedLocations" 
                    title="Your preferred locations"
                    subtitle="If you'd like to work in specific places you can specify them here"
                    value={preferences.likedLocations} 
                    onChange={onChange} />
                <MemberLocationList 
                    list="dislikedLocations" 
                    title="Anywhere you'd prefer not to work"
                    subtitle="If you'd rather not work in specific places you can specify them here"
                    value={preferences.dislikedLocations} 
                    onChange={onChange} />
            </div>
        </Paper>
    )
}

export default MemberPreferencesContent;